module.exports = __webpack_public_path__ + "img/personal-account--mobile.39d8862.webp";